module.exports = __webpack_public_path__ + "img/about-2.ddf39f65.png";